"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/SecondaryNav.style"));
var _IconNav = _interopRequireDefault(require("./components/IconNav"));
var _UserIcon = _interopRequireDefault(require("./components/UserIcon"));
var _SearchIcon = _interopRequireDefault(require("./components/SearchIcon"));
var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var SecondaryNav = function SecondaryNav(_ref) {
  var dataSelectorPrefix = _ref.dataSelectorPrefix;
  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
    secondaryNav = _ref2.secondaryNav;
  return /*#__PURE__*/_react["default"].createElement(Styled.SecondaryNav, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (secondaryNav === null || secondaryNav === void 0 ? void 0 : secondaryNav.iconNavLinks) && /*#__PURE__*/_react["default"].createElement(_IconNav["default"], {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'icon-nav')
  })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (secondaryNav === null || secondaryNav === void 0 ? void 0 : secondaryNav.search) && /*#__PURE__*/_react["default"].createElement(_SearchIcon["default"], {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'search-icon')
  })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (secondaryNav === null || secondaryNav === void 0 ? void 0 : secondaryNav.user) && /*#__PURE__*/_react["default"].createElement(_UserIcon["default"], {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'user-icon')
  })));
};
SecondaryNav.displayName = "SecondaryNav";
var _default = SecondaryNav;
exports["default"] = _default;